import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioSolitudServiciosService {
  constructor(private requestUrl: ReportesRequestService) { }

  async getSuministros(params: ParametrosSolitudServiciosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'solicitud-servicios/suministros',
        [params.codigo, { ln_unco_hstra_clnca: params.unco }]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getSuministrosEvolucion(params: ParametrosSolitudServiciosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'solicitud-servicios/suministros-evolucion',
        [params.codigo, { ln_unco_relacion_crono: params.unco }]
      );
      return response;

    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getProfesionalesFormulaMedica(params: ParametrosSolitudServiciosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'solicitud-servicios/profesionales-formula-medica',
        [params.codigo, { ln_unco_hstra_clnca: params.unco }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getDatosGenerales(params: ParametrosSolitudServiciosEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-servicios/datos-generales',
        [params.codigo, {
          ln_unco_hstra_clnca: params.unco,
          lb_frmto_prmprso: 0
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getDatosGeneralesEvolucion(params: ParametrosSolitudServiciosEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-servicios/datos-generales-evolucion',
        [params.codigo, {
          ln_unco_relacion_crono: params.unco,
          lb_frmto_prmprso: 1
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getFormulasMedicas(params: ParametrosSolitudServiciosEntity,
    filtros: ReporteFormulasMedicasFiltro) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-servicios/formulas',
        [params.codigo, {
          unco_suministros: filtros.suminsitros,
          unco_profesionales: filtros.profesionales,
          unco_hc: params.unco
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getFormulasMedicasEvolucion(params: ParametrosSolitudServiciosEntity,
    filtros: ReporteFormulasMedicasFiltro) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-servicios/formulas-evolucion',
        [params.codigo, {
          unco_suministros: filtros.suminsitros,
          unco_relacion_crono: params.unco
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getProcedimientosHistoria(params: ParametrosSolitudServiciosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'reporte-solicitud-servicios/servicios-historia',
        [params.codigo, { uncoHistoria: params.unco }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getProcedimientosEvolucion(params: ParametrosSolitudServiciosEntity) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'reporte-solicitud-servicios/servicios-evolucion',
        [params.codigo, { uncoEvolucion: params.unco }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getOrdenesMedicas(params: ParametrosSolitudServiciosEntity, procedimientos: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-servicios/ayudas-dx',
        [params.codigo, {
          uncoHistoria: params.unco,
          procedimientos
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getOrdenesMedicasHistoria(params: ParametrosSolitudServiciosEntity, procedimientos: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-servicios/ayudas-dx-historia',
        [params.codigo, {
          uncoHistoria: params.unco,
          procedimientos
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  async getOrdenesMedicasEvolucion(params: ParametrosSolitudServiciosEntity, procedimientos: string) {
    try {
      const response = await this.requestUrl.getRequest(
        'solicitud-servicios/ayudas-dx-evolucion',
        [params.codigo, {
          uncoEvolucion: params.unco,
          procedimientos
        }]
      );
      return response;
    } catch (e) {
      alert(e);
    }
    return null;
  }

  getDatosGeneralesEntity(data: any): DatosGeneralesEntity {
    const datos = data[0];
    const datosGenerales = {} as DatosGeneralesEntity;
    datosGenerales.identificacion = datos['idntfccn'];
    datosGenerales.historiaClinica = datos["hstra_clnca"];
    datosGenerales.paciente = datos["paciente"];
    datosGenerales.afiliado = datos["afiliado"];
    datosGenerales.fechaNac = datos["fcha_ncmnto"];
    datosGenerales.direccion = datos["drccn"];
    datosGenerales.telefono = datos["tlfno"];
    datosGenerales.tipoAfiliado = datos["tpo_afldo"];
    datosGenerales.empresa = datos["emprsa"];
    datosGenerales.sexo = datos["sexo"];
    datosGenerales.estrato = datos["dscrpcn_estrto"];
    datosGenerales.sede = datos["dscrpcn_sde"];
    datosGenerales.puntoAtencion = datos["dscrpcn_pnto_atncn"];
    datosGenerales.fechaAtencion = datos["fcha_atncn"];
    datosGenerales.tipoAtencion = datos["tpo_atncn"];
    datosGenerales.profesional = datos["prfsnl_sld"];
    datosGenerales.identificacionProfesional = datos["idntfccn_prfsnl"];
    datosGenerales.registroMedico = datos["rgstro_mdco"];
    datosGenerales.edad = datos["edd"];
    datosGenerales.firmaDigital = datos["frma_dgtl"];
    datosGenerales.entidadEmpresarial = datos["entdd_emprsrl"];
    datosGenerales.especialidad = datos["espcldd"];
    datosGenerales.documento = datos["dcmnto"];
    datosGenerales.lineaProductoHc = datos["dscrpcn_lna_prdcto_hstra_clnca"];
    datosGenerales.cllr = datos["cllr"];
    datosGenerales.codigo = datos["cdgo"];
    datosGenerales.uncoEntidad = datos["unco_entidad"];
    datosGenerales.uncoProfesional = datos["unco_prfsnl_sld"];
    return datosGenerales;
  }
}

export interface ParametrosSolitudServiciosEntity {
  codigo: string;
  uncoLogin: number;
  unco: number;
  uncoSede: number;
}

export enum TipoReporte {
  SOLO_HISTORIA = "1",
  CONSOLIDADO = "2"
}

export interface ReporteFormulasMedicasFiltro {
  discriminarNoPos: boolean;
  fechaOrden: string;
  suminsitros: string;
  profesionales: string;
}

export interface ReporteOrdenMedicasFiltro {
  procedimientos: string;
  tipoReporte: TipoReporte;
  impresionServicios: boolean;
  discriminarServicios: boolean;
  discriminarNoPos: boolean;
}

export interface DatosGeneralesEntity {
  afiliado: string;
  cllr: string;
  codigo: number;
  direccion: string;
  documento: string;
  edad: string;
  firmaDigital: string;
  empresa: string;
  entidadEmpresarial: string;
  especialidad: string;
  estrato: string;
  fechaAtencion: string;
  fechaNac: string;
  historiaClinica: string;
  identificacion: string;
  identificacionProfesional: string;
  lineaProductoHc: string;
  paciente: string;
  profesional: string;
  puntoAtencion: string;
  registroMedico: string;
  sede: string;
  sexo: string;
  telefono: string;
  tipoAfiliado: string;
  tipoAtencion: string;
  uncoEntidad: number;
  uncoProfesional: number;
}

export interface FormulaMedicaEntity {
  activaDescripcionDx1: string;
  activaDescripcionDx2: string;
  activaDescripcionDx: boolean;
  autorizacion: string;
  cantidad: number;
  cantidadLetras: string;
  codigoDx1: string;
  codigoDx2: string;
  codigoDx: string;
  codigoMedicamento: string;
  consecutivoFormula: number;
  descripcionDx1: string;
  descripcionDx2: string;
  descripcionDx: string;
  descripcionMedicamento: string;
  diagnostico1: string;
  diagnostico2: string;
  diagnostico: string;
  diasValidez: number;
  dosisMedicamento: string;
  duracion: string;
  especialidad: string;
  firmaDigital: string;
  frecuencia: string;
  identificacion: string;
  indicaciones: string;
  numeroFormula: number;
  observaciones: string;
  presentacion: string;
  profesional: string;
  registroMedico: string;
  tipoSuministro: number;
  uncoProfesional: number;
  viaAdministracion: string;
}

export interface OrdenMedicaEntity {
  cantidad: number;
  fechaOrden: string;
  fechaValidez: string;
  consecutivoAyudaDx: string;
  indicaciones: string;
  observaciones: string;
  numeroAutorizacionWS: string;
  validezOrden: string;
  diagnostico: DiagnosticoEntity;
  diagnosticoRel1: DiagnosticoEntity;
  diagnosticoRel2: DiagnosticoEntity;
  pertinenciaMedica: string;
  procedimiento: {
    tipoServicioPos: boolean;
    unco: number;
    codigo: number;
    uncoLineaProducto: number;
    codigoCups: string;
    codigoProcedimiento: string;
    descripcion: string;
  };
  profesional: string;
  lineaProducto: {
    unco: number;
    agrupacion: boolean;
    descripcion: string;
  }
}

export interface DiagnosticoEntity {
  unco: number;
  activaDescripcion: boolean;
  codigoDiagnostico: string;
  descripcion: string;
}